// Canonical helpers for feeding sessions. D1 stores `segments` as a TEXT
// column; we lazily parse to a typed array. Used by both web (display) and
// api (mutations) so the parse logic doesn't drift.

import type { BreastSegment } from './types.ts';

export function parseSegments(
  v: BreastSegment[] | string | null | undefined,
): BreastSegment[] {
  if (!v) return [];
  if (Array.isArray(v)) return v;
  try {
    const arr = JSON.parse(v);
    return Array.isArray(arr) ? (arr as BreastSegment[]) : [];
  } catch {
    return [];
  }
}

/** Append an "active" segment (from the last segment's end, or the session
 *  start if none yet) up to `now`. Used by stop/switch/pause handlers so
 *  they all account for the in-progress side identically. */
export function appendActiveSegment(
  prev: BreastSegment[] | string | null | undefined,
  side: 'left' | 'right',
  sessionStartedAt: number,
  now: number,
): BreastSegment[] {
  const segs = parseSegments(prev);
  const boundary = segs.length ? segs[segs.length - 1].to : sessionStartedAt;
  if (now <= boundary) return segs;
  return [...segs, { side, from: boundary, to: now }];
}
